<script setup lang="ts">
import { Form } from "@primevue/forms";
import { alerts } from "../common/alert.common";

const props = defineProps<{
    submit?: () => Promise<void>;
    validate?: () => Promise<boolean>;
}>();

async function onSubmit() {
    const isValid = await props.validate?.();

    if (isValid ?? true) {
        await props.submit?.();
    } else {
        alerts.form.incomplete();
    }
}
</script>

<template>
    <Form @submit="onSubmit">
        <slot></slot>
    </Form>
</template>
